/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_table_find_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find a constructor... (e.g. RED+MCL)`)
};

const es_f1_table_find_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar constructor... (ej. RED+MCL)`)
};

const de_f1_table_find_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konstrukteur suchen... (z.B. RED+MCL)`)
};

const nl_f1_table_find_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Constructeur zoeken... (bijv. RED+MCL)`)
};

const fr_f1_table_find_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trouver un constructeur... (ex. RED+MCL)`)
};

const it_f1_table_find_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trova costruttore... (es. RED+MCL)`)
};

const pt_br2_f1_table_find_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar construtor... (ex. RED+MCL)`)
};

const pt_f1_table_find_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontrar construtor... (ex. RED+MCL)`)
};

const ja_f1_table_find_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンストラクターを検索... (例: RED+MCL)`)
};

const zh_f1_table_find_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查找车队...（如 RED+MCL）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_table_find_constructor = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_table_find_constructor(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_table_find_constructor", locale)
	if (locale === "en") return en_f1_table_find_constructor(inputs)
	if (locale === "es") return es_f1_table_find_constructor(inputs)
	if (locale === "de") return de_f1_table_find_constructor(inputs)
	if (locale === "nl") return nl_f1_table_find_constructor(inputs)
	if (locale === "fr") return fr_f1_table_find_constructor(inputs)
	if (locale === "it") return it_f1_table_find_constructor(inputs)
	if (locale === "pt-BR") return pt_br2_f1_table_find_constructor(inputs)
	if (locale === "pt") return pt_f1_table_find_constructor(inputs)
	if (locale === "ja") return ja_f1_table_find_constructor(inputs)
	return zh_f1_table_find_constructor(inputs)
};